import { selectBasketDeliveries, selectBasketList } from 'containers/OrderDetails/basketSlice'
import useTranslation from 'hooks/useTranslation'
import { useReduxSelector } from 'store'
import { Fragment } from 'react'

const DeliverySection = () => {
  const deliveries = useReduxSelector(selectBasketDeliveries)
  const list = useReduxSelector(selectBasketList)
  const { t } = useTranslation('basket')

  const data = deliveries?.reduce((r, delivery) => {
    const productWithDelivery = list.filter(l => l.deliveryId === delivery.id)
    if (productWithDelivery.length > 0) {
      r.push({
        id: delivery.id,
        name: t(delivery.type),
        desc: delivery.pointId
          ? `${delivery.pointId}${delivery.lockerId ? `, ${t('locker')} ${delivery.lockerId}` : ''}`
          : delivery.address
            ? `${delivery.address.street} ${delivery.address.estateNumber}${delivery.address.localNumber ? `/${delivery.address.localNumber}` : ''}, ${delivery.address.zip} ${delivery.address.city}`
            : undefined,
        products: productWithDelivery
      })
    }
    return r
  }, [])

  if (!data || data.length === 0) {
    return null
  }

  return (
    <div>
      <div className='list__header element__title'>{t('delivery')}</div>
      <div className='list__element --big'>
        {data.map(({ id, name, desc, products }) => <Fragment key={id}>
          <div className='element__title'>{name}:</div>
          {desc && <div className='element__desc'>{desc}</div>}
          <div className='element__desc'>
            {products.map(({ name }, idx) => <div key={idx}>- {name}</div>)}
          </div>
        </Fragment>)}
      </div>
    </div>
  )
}

export default DeliverySection